import React from 'react';
import PropTypes from 'prop-types';
import I18n from '@utils/i18n';

function VisitsCell({ dataItem }) {
  const handleVisitClick = (e, visitId) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('openVisitModal', { detail: visitId }));
  };

  return (
    <td>
      {dataItem.visits.map((visit) => (
        <div key={visit.id}>
          <a href="#" onClick={(e) => handleVisitClick(e, visit.id)}>
            {visit.scheduled_date} - {visit.building_name}
          </a>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <span className="qmb-avatar--24--status-icon">
            <i className={`fa-lg ${visit.status_icon}`} style={{ color: visit.status_color }} />
          </span>
          <span style={{ marginLeft: '0.5rem' }}>{I18n.t(`enums.visit.visit_statuses.${visit.status}`)}</span>
        </div>
      ))}
    </td>
  );
}

VisitsCell.propTypes = {
  dataItem: PropTypes.shape({
    visits: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        scheduled_date: PropTypes.string,
        building_name: PropTypes.string,
        status: PropTypes.string,
        status_icon: PropTypes.string,
        status_color: PropTypes.string
      })
    )
  }).isRequired
};

export default VisitsCell;
